/* ==========================================================================
   QUICK ADD — logic
   Opens the panel from every product card's .card-varient-tap-btn, feeds it
   from the card's own <script data-card-variants> JSON (server-rendered, so
   prices are already in the shopper's currency), adds via /cart/add.js and
   hands off to the theme's cart_drawer_update().

   No edits to script.js: its old handler on the same button (which opened
   the now-hidden .product-varient row) is starved by a document-level
   CAPTURE listener that stops the event before it ever reaches the button.

   Delegated at document level on purpose — cards injected later (cart
   drawer re-renders, section rendering API) need no MutationObserver.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__nsQuickAdd) return;
  window.__nsQuickAdd = true;

  var state = {card: null, colors: [], sizes: [], colorIdx: -1, sizeIdx: -1,
               color: null, size: null, variants: [], opener: null};

  /* ---------- helpers ---------------------------------------------------- */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[c];
    });
  }
  function thumbUrl(u) {
    /* card JSON serialises images at width=1000; the 62/84px thumbs only need 200 */
    return String(u || '').replace(/width=1000/, 'width=200');
  }

  /* ---------- data from a card ------------------------------------------- */
  function readCard(card) {
    var node = $('script[data-card-variants]', card);
    if (!node) return null;
    var variants;
    try { variants = JSON.parse(node.textContent); } catch (e) { return null; }
    if (!variants || !variants.length) return null;

    var colorIdx = parseInt(card.getAttribute('data-color-index'), 10);
    var sizeIdx = parseInt(card.getAttribute('data-size-index'), 10);
    if (!isFinite(colorIdx)) colorIdx = -1;
    if (!isFinite(sizeIdx)) sizeIdx = -1;

    var optionNames = (card.getAttribute('data-option-names') || '').split('||');

    /* The card only detects options literally NAMED Size/Storlek. A product
       whose choice axis has any other name ("Shoe size" on sandals, measured
       2026-08-22) came through with sizeIdx -1, and the panel silently sold
       the FIRST variant — size 40, whoever you are. Generic fallback: any
       option that isn't the colour axis and varies across variants becomes
       the choice grid, labelled with its real option name. */
    var distinct = [];
    variants.forEach(function (v) {
      (v.options || []).forEach(function (val, i) {
        distinct[i] = distinct[i] || {};
        if (val != null) distinct[i][val] = true;
      });
    });
    var countAt = function (i) { return Object.keys(distinct[i] || {}).length; };
    if (sizeIdx < 0) {
      for (var oi = 0; oi < distinct.length; oi++) {
        if (oi !== colorIdx && countAt(oi) > 1) { sizeIdx = oi; break; }
      }
    }
    var sizeLabel = (sizeIdx >= 0 && optionNames[sizeIdx]) ? optionNames[sizeIdx] : 'Size';

    /* A third varying axis beyond colour + choice can't be represented in
       this panel — send the shopper to the product page instead of guessing
       a variant for them. */
    for (var oj = 0; oj < distinct.length; oj++) {
      if (oj !== colorIdx && oj !== sizeIdx && countAt(oj) > 1) return null;
    }

    var colors = [], sizes = [], seenC = {}, seenS = {};
    variants.forEach(function (v) {
      if (colorIdx >= 0) {
        var c = v.options[colorIdx];
        if (c != null && !seenC[c]) { seenC[c] = true; colors.push(c); }
      }
      if (sizeIdx >= 0) {
        var s = v.options[sizeIdx];
        if (s != null && !seenS[s]) { seenS[s] = true; sizes.push(s); }
      }
    });

    var titleEl = $('.card-title', card);
    return {
      card: card,
      variants: variants,
      colorIdx: colorIdx,
      sizeIdx: sizeIdx,
      sizeLabel: sizeLabel,
      colors: colors,
      sizes: sizes,
      title: titleEl ? titleEl.textContent.trim() : '',
      type: card.getAttribute('data-product-type') || '',
      handle: card.getAttribute('data-product-handle') || '',
      url: (titleEl && titleEl.getAttribute && titleEl.getAttribute('href')) ||
           card.getAttribute('data-product-url') || '#',
      cardImg: (function () {
        var img = $('.card-slider-img img', card);
        return img ? img.currentSrc || img.src : '';
      })()
    };
  }
  function variantFor(color, size) {
    var hit = null;
    state.variants.some(function (v) {
      var okC = state.colorIdx < 0 || color == null || v.options[state.colorIdx] === color;
      var okS = state.sizeIdx < 0 || size == null || v.options[state.sizeIdx] === size;
      if (okC && okS) { hit = v; return true; }
      return false;
    });
    return hit;
  }
  function colorHasStock(color) {
    return state.variants.some(function (v) {
      return v.options[state.colorIdx] === color && v.available;
    });
  }
  function imageFor(color) {
    var withImg = null;
    state.variants.some(function (v) {
      if ((state.colorIdx < 0 || v.options[state.colorIdx] === color) && v.featured_image) {
        withImg = v.featured_image; return true;
      }
      return false;
    });
    return withImg || state.cardImg || '';
  }

  /* ---------- rendering --------------------------------------------------- */
  var sheet, scrim;
  function paintPrice(v) {
    var el = $('.ns-qa__price', sheet);
    if (!el) return;
    var html = '';
    if (v && v.compare_at_price && v.compare_at_price > v.price) {
      html += '<p class="previous-price">' + esc(v.compare_at_price_formatted) + '</p>';
    }
    html += '<p class="latest-price">' + esc(v ? v.price_formatted : '') + '</p>';
    el.innerHTML = html;
    var atcPrice = $('[data-qa-atc-price]', sheet);
    if (atcPrice) atcPrice.textContent = v ? v.price_formatted : '';
  }
  /* STOQ (the preorder app, app-embedded on every page) inlines a
     variant-id -> ship-time map in window._RestockRocketConfig
     ("52607161532680": "2-3 weeks", ...) plus the campaign's own display
     template ("Ships in: {{ date }}"). Reading it gives the panel the exact
     same line the PDP widget shows, per variant, with no extra request.
     Walked lazily on every paint: the config script is deferred and may not
     have run yet the first time the sheet opens. */
  function stoqShipFor(variantId) {
    var cfg = window._RestockRocketConfig;
    if (!cfg || !variantId) return null;
    var text = null, tmpl = null;
    (function walk(o, depth) {
      if (text || !o || typeof o !== 'object' || depth > 4) return;
      if (o.variant_shipping_texts && typeof o.variant_shipping_texts === 'object') {
        var t = o.variant_shipping_texts[String(variantId)];
        if (t) { text = t; tmpl = o.preorder_shipping_text || null; return; }
      }
      for (var k in o) {
        if (text) return;
        if (Object.prototype.hasOwnProperty.call(o, k) && o[k] && typeof o[k] === 'object') walk(o[k], depth + 1);
      }
    })(cfg, 0);
    if (!text) return null;
    return (tmpl && /\{\{\s*date\s*\}\}/.test(tmpl))
      ? tmpl.replace(/\{\{\s*date\s*\}\}/, text)
      : 'Ships in: ' + text;
  }

  function paintStock(v) {
    var el = $('.ns-qa__stock', sheet);
    if (!el) return;
    var pre = !!(v && v.preorder);
    el.classList.toggle('is-preorder', pre);
    var line;
    if (pre) {
      line = stoqShipFor(v.id) || 'Pre-order – ships as soon as it restocks';
    } else {
      line = el.dataset.qaInstock || 'In Stock – Ships within 4-7 days'; /* store-specific text from the sheet */
    }
    $('[data-qa-stock-text]', sheet).textContent = line;
    var label = $('[data-qa-atc-label]', sheet);
    if (label) label.textContent = pre ? 'Pre-order' : 'Add to cart';
  }
  /* VARIANT-scoped, not product-scoped: the heart reflects and saves the
     exact variant being looked at (colour + size when chosen, the colour's
     first variant before a size is picked). Same scope as the PDP heart, so
     the wishlist drawer shows the precise item, not a guess. */
  function wishVariant() {
    return variantFor(state.color, state.size) || variantFor(state.color, null) || state.variants[0];
  }
  function paintWish() {
    var w = $('.ns-qa__wish', sheet);
    if (!w) return;
    if (!window.NSWishlist || !state.handle) { w.hidden = true; return; }
    w.hidden = false;
    var v = wishVariant();
    var on = window.NSWishlist.has(state.handle, v ? v.id : undefined);
    w.classList.toggle('on', on);
    w.setAttribute('aria-pressed', on ? 'true' : 'false');
  }
  function paintColor() {
    var img = imageFor(state.color);
    var t = $('.ns-qa__thumb img', sheet);
    if (t && img) { t.src = img; t.alt = state.title; }
    var val = $('[data-qa-color-name]', sheet);
    if (val) val.textContent = state.color || '';
    $all('.ns-qa__colors button', sheet).forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-color') === state.color ? 'true' : 'false');
    });
    /* re-enable/disable sizes for this colour */
    $all('.ns-qa__size', sheet).forEach(function (b) {
      var v = variantFor(state.color, b.getAttribute('data-size'));
      var ok = !!(v && v.available);
      b.disabled = !ok;
      b.setAttribute('data-preorder', ok && v.preorder ? 'true' : 'false');
    });
    /* keep the selected size only if it still exists in this colour */
    if (state.size) {
      var still = variantFor(state.color, state.size);
      if (!still || !still.available) { state.size = null; }
    }
    paintSize();
  }
  function paintSize() {
    $all('.ns-qa__size', sheet).forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-size') === state.size ? 'true' : 'false');
    });
    var val = $('[data-qa-size-name]', sheet);
    if (val) val.textContent = state.size || 'Select a size';
    var v = variantFor(state.color, state.size) || variantFor(state.color, null);
    paintPrice(v);
    paintStock(state.size ? variantFor(state.color, state.size) : v);
    paintWish();
    err('');
  }
  function err(msg) {
    var el = $('.ns-qa__err', sheet);
    if (el) el.textContent = msg || '';
  }

  /* ---------- open / close ------------------------------------------------ */
  function open(card, opener) {
    var data = readCard(card);
    if (!data) { /* no data: fall through to the product page */
      var link = $('.card-title', card);
      if (link && link.href) window.location.href = link.href;
      return;
    }
    state = data;
    state.opener = opener || null;

    /* preselect the colour the card is showing right now */
    var sel = $('.card-color-swatch.is-selected', card);
    var selVal = sel && sel.getAttribute('data-color-value');
    state.color = (selVal && state.colors.indexOf(selVal) !== -1) ? selVal
                : (state.colors[0] || null);
    state.size = null;

    $('[data-qa-eyebrow]', sheet).textContent = state.type || '';
    $('[data-qa-name]', sheet).textContent = state.title;
    var pdp = $('[data-qa-pdp-link]', sheet);
    if (pdp) pdp.href = state.url;
    var sl = $('[data-qa-size-label]', sheet);
    if (sl) sl.textContent = (state.sizeLabel || 'Size') + ':';

    /* colour thumbs */
    var cwrap = $('.ns-qa__colors', sheet);
    var cblock = $('[data-qa-color-block]', sheet);
    if (state.colorIdx >= 0 && state.colors.length > 1) {
      cblock.hidden = false;
      cwrap.innerHTML = state.colors.map(function (c) {
        var img = thumbUrl(imageFor(c));
        var dim = colorHasStock(c) ? '' : ' style="opacity:.4"';
        return '<button type="button" data-color="' + esc(c) + '" aria-pressed="false"' +
               ' aria-label="' + esc(c) + '" title="' + esc(c) + '"' + dim + '>' +
               (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : esc(c)) + '</button>';
      }).join('');
    } else {
      cblock.hidden = true;
      cwrap.innerHTML = '';
    }

    /* size grid */
    var swrap = $('.ns-qa__sizes', sheet);
    var sblock = $('[data-qa-size-block]', sheet);
    if (state.sizeIdx >= 0 && state.sizes.length) {
      sblock.hidden = false;
      swrap.innerHTML = state.sizes.map(function (s) {
        return '<button type="button" class="ns-qa__size" data-size="' + esc(s) + '" aria-pressed="false">' + esc(s) + '</button>';
      }).join('');
    } else {
      sblock.hidden = true;
      swrap.innerHTML = '';
      /* single-variant product: it is directly addable */
    }

    var thumb = $('.ns-qa__thumb', sheet);
    thumb.innerHTML = '<img src="' + esc(imageFor(state.color)) + '" alt="' + esc(state.title) + '">';

    paintColor();
    paintWish();

    scrim.classList.add('on');
    sheet.classList.add('on');
    document.body.classList.add('ns-qa-lock');
    var closeBtn = $('.ns-qa__close', sheet);
    if (closeBtn) closeBtn.focus();
  }
  function close() {
    scrim.classList.remove('on');
    sheet.classList.remove('on');
    document.body.classList.remove('ns-qa-lock');
    if (state.opener && state.opener.focus) { try { state.opener.focus(); } catch (e) {} }
  }

  /* ---------- add to cart ------------------------------------------------- */
  function addToCart() {
    var needsSize = state.sizeIdx >= 0 && state.sizes.length;
    if (needsSize && !state.size) {
      err('Select a size first');
      var grid = $('.ns-qa__sizes', sheet);
      if (grid && grid.animate) {
        grid.animate([{transform: 'translateX(0)'}, {transform: 'translateX(-5px)'},
                      {transform: 'translateX(5px)'}, {transform: 'translateX(0)'}], {duration: 240});
      }
      return;
    }
    var v = variantFor(state.color, needsSize ? state.size : null);
    if (!v) { err('This combination is not available.'); return; }
    if (!v.available) { err('This option is sold out – please pick another.'); return; }

    var atc = $('.ns-qa__atc', sheet);
    atc.setAttribute('aria-busy', 'true');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({id: v.id, quantity: 1})
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Could not add to cart'); });
      return r.json();
    }).then(function () {
      atc.removeAttribute('aria-busy');
      close();
      /* same hand-off as the theme's own add flow */
      if (window.jQuery) {
        window.jQuery('.cart-sidebar').addClass('active');
        window.jQuery('body').addClass('active');
      }
      if (typeof window.cart_drawer_update === 'function') window.cart_drawer_update();
    }).catch(function (e) {
      atc.removeAttribute('aria-busy');
      err(e && e.message ? e.message : 'Could not add to cart – please try again.');
    });
  }

  /* ---------- wiring ------------------------------------------------------ */
  function init() {
    sheet = document.getElementById('ns-quick-add');
    scrim = document.getElementById('ns-quick-add-scrim');
    if (!sheet || !scrim) return;

    /* capture phase: reach the event before script.js's own handler does */
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest && e.target.closest('.card-varient-tap-btn');
      if (!btn) return;
      var card = btn.closest('.product-card');
      if (!card) return;
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      open(card, btn);
    }, true);

    scrim.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sheet.classList.contains('on')) close();
    });

    sheet.addEventListener('click', function (e) {
      if (e.target.closest('.ns-qa__close')) { close(); return; }

      var c = e.target.closest('.ns-qa__colors button');
      if (c) {
        state.color = c.getAttribute('data-color');
        paintColor();
        /* sync the card: its own swatch handler swaps the slider image too */
        try {
          var cardSw = $('.card-color-swatch[data-color-value="' +
            (window.CSS && CSS.escape ? CSS.escape(state.color) : state.color) + '"]', state.card);
          if (cardSw && !cardSw.classList.contains('is-selected')) cardSw.click();
        } catch (ignore) {}
        return;
      }

      var s = e.target.closest('.ns-qa__size');
      if (s && !s.disabled) {
        state.size = s.getAttribute('data-size');
        paintSize();
        return;
      }

      if (e.target.closest('.ns-qa__atc')) { addToCart(); return; }

      var w = e.target.closest('.ns-qa__wish');
      if (w && window.NSWishlist && state.handle) {
        var v = wishVariant();
        var on = window.NSWishlist.toggle(state.handle, v ? v.id : null, true);
        w.classList.toggle('on', on);
        w.setAttribute('aria-pressed', on ? 'true' : 'false');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
